<template>
  <div
    class="flex-valign broadcast-page"
    v-loading="dataLoading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    :class="{ showPanel: !showPanels }"
  >
    <div class="blur-bg map-blur-panel"></div>
    <div class="flex-between title">
      <div>{{ broadcastPageType == 1 ? "远程喊话" : "公共广播播放音频" }}</div>
    </div>
    <el-scrollbar
      class="ioc-alarm__scrollbar"
      style="height: calc(100% - 110px) !important"
    >
      <el-form
        ref="panelForm"
        :model="panelForm"
        class="panelForm"
        :rules="formRules"
      >
        <el-form-item
          prop="playTime"
          label="播放时长/s"
          v-if="broadcastPageType == 2"
        >
          <template>
            <el-input
              type="number"
              maxlength="10"
              style="width: 70%"
              placeholder="请输入音频播放时长"
              v-model="panelForm.playTime"
            >
            </el-input>
          </template>
        </el-form-item>
        <el-form-item
          prop="playOrder"
          label="播放顺序"
          v-if="broadcastPageType == 2"
        >
          <template>
            <el-select
              style="width: 73%"
              v-model="panelForm.playOrder"
              clearable
              placeholder="请选择音频播放顺序"
            >
              <el-option
                v-for="item in playOrders"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-form-item>
        <el-form-item
          prop="sourceId"
          label="选择话筒"
          v-if="broadcastPageType == 1"
        >
          <template>
            <el-button
              @click="handleAddDevice"
              icon="el-icon-plus"
              style="position: absolute; right: 10px; top: 0px"
            >
              添加
            </el-button>
            <div class="form-list">
              <div class="content_value" v-if="panelForm.sourceName">
                <i class="item-icon el-icon-microphone"></i>
                {{ panelForm.sourceName || "" }}
              </div>
              <div class="no-data-text" v-else>暂无话筒设备</div>
            </div>
          </template>
        </el-form-item>
        <el-form-item
          prop="audioList"
          label="已选音频文件"
          v-if="broadcastPageType == 2"
        >
          <span>/ {{ panelForm.audioList.length }}</span>
          <template>
            <el-button
              @click="handleAddAudio"
              icon="el-icon-plus"
              style="position: absolute; right: 10px; top: 0px"
            >
              添加
            </el-button>
            <div class="form-list" v-if="panelForm.audioList.length">
              <div
                class="device-item"
                v-for="(item, index) in panelForm.audioList"
                :key="'intercom-device-' + index"
              >
                <div class="flex-auto text-ellipse" :title="item">
                  <i class="item-icon iconfont-lunan icon-lunan-guangbo"></i>
                  {{ item }}
                </div>
                <el-button
                  title="删除"
                  type="text"
                  style="font-size: 20px"
                  icon="el-icon-remove-outline"
                  @click="handleDelDevice(item, index, 3)"
                ></el-button>
              </div>
            </div>
            <div class="form-list" v-else>
              <div class="no-data-text">暂无音频文件</div>
            </div>
          </template>
        </el-form-item>
        <el-form-item prop="deviceList" label="已选广播设备">
          <span>/ {{ panelForm.deviceList.length }}</span>
          <template>
            <el-button
              @click="handleChooseDevice(2)"
              icon="el-icon-plus"
              style="position: absolute; right: 10px"
            >
              添加
            </el-button>

            <div class="form-list" v-if="panelForm.deviceList.length">
              <div
                class="device-item"
                v-for="(item, index) in panelForm.deviceList"
                :key="'intercom-device-' + index"
              >
                <div
                  class="flex-auto text-ellipse"
                  style="cursor: pointer"
                  :title="item.name"
                  @click="handelCenterPoint(item)"
                >
                  <i class="item-icon iconfont-lunan icon-lunan-guangbo"></i>
                  {{ item.name || item.attr.thirdDeviceName }}
                </div>
                <el-button
                  title="删除"
                  type="text"
                  style="font-size: 20px"
                  icon="el-icon-remove-outline"
                  @click="handleDelDevice(item, index)"
                ></el-button>
              </div>
            </div>
            <div class="form-list" v-else>
              <div class="no-data-text">暂无广播设备</div>
            </div>
          </template>
        </el-form-item>
      </el-form>
    </el-scrollbar>
    <div class="footer">
      <el-button type="info" @click="handleClosePanel" :loading="btnLoading">{{
        btnLoading ? "提交中" : "取消"
      }}</el-button>
      <el-button
        type="primary"
        v-if="broadcastPageType == 1"
        @click="handleSavePanel"
        :loading="btnLoading"
        >{{ btnLoading ? "提交中" : "确定" }}</el-button
      >
      <el-button
        type="primary"
        v-if="broadcastPageType == 2"
        @click="handleSaveAudio"
        :loading="btnLoading"
        >{{ btnLoading ? "提交中" : "确定" }}</el-button
      >
    </div>
    <devicePanel
      ref="deviceRef"
      :deviceTitle="devicePanelTitle"
      :showIntercomList="showIntercomList"
      :isType="isType"
      :broadcastArray="$attrs.broadcastArray"
      :broadcastPageType="broadcastPageType"
      :panelPlaceholder="panelPlaceholder"
      @handleClose="handleClose"
      @handleConfirm="handleConfirm"
      @handleConfirmList="handleConfirmList"
    />
  </div>
</template>

<script>
import { api } from "../api";
import devicePanel from "./broadcastDevice";
export default {
  components: {
    devicePanel,
  },
  props: {
    showPanel: {
      type: Boolean,
      default: false,
    },
    refMap: {
      type: Object,
      default: () => {
        return null;
      },
    },
    layerId: {
      type: String,
      default: "",
    },
    broadcastPageType: {
      type: Number,
      default: 1,
    },
  },
  watch: {
    showPanel: {
      handler(val) {
        this.showPanels = val;
      },
      immediate: true,
    },
  },
  data() {
    return {
      broadcastSrc: "images/theme/newDark/map/resource/broadcast_inactive.png",
      broadcastCheckSrc:
        "images/theme/newDark/map/resource/broadcast-live_selected.png", //选中,
      btnLoading: false,
      devicePanelTitle: "",
      isType: 0,
      panelPlaceholder: "",
      showIntercomList: false,
      panelForm: {
        sourceId: "", //话筒
        playTime: "", //时长
        playOrder: "", //顺序
        micList: [], //话筒详情
        deviceList: [], //广播
        audioList: [], //音频
      },
      formRules: {
        playTime: [
          {
            required: true,
            message: "请输入时间",
            trigger: "blur",
          },
        ],
        playOrder: [
          {
            required: true,
            message: "请选择顺序",
            trigger: "change",
          },
        ],
        sourceId: [
          {
            required: true,
            message: "请添加话筒设备",
            trigger: "change",
          },
        ],
        audioList: [
          {
            required: true,
            message: "请添加音频文件",
            trigger: "change",
          },
        ],
        deviceList: [
          {
            required: true,
            message: "请添加广播设备",
            trigger: "change",
          },
        ],
      },
      showPanels: false,
      dataLoading: false,
      playOrders: [
        {
          value: "0",
          label: "顺序播放",
        },
        {
          value: "1",
          label: "随机播放",
        },
      ],
    };
  },
  mounted() {
    // this.getRecordList();
  },
  methods: {
    // 统一处理地图选中和弹窗选中的数据列表
    handleDealDevice(info, option) {
      // console.log(info);
      let obj = {
        latitude: info.latitude,
        longitude: info.longitude,
        isIndoor: info.isIndoor,
        name: info.deviceName || info.name,
        thirdCameraId: info.thirdCameraId, //第三方设备id
        deviceId: info.deviceId || info.id, //入库映射id
      };
      let findIndex = this.panelForm.deviceList.findIndex((el) => {
        return el.thirdCameraId == obj.thirdCameraId;
      });
      // console.log(findIndex);
      if (findIndex != -1) {
        this.panelForm.deviceList.splice(findIndex, 1);
        this.refMap.updateFeatureById(
          this.layerId,
          this.layerId + "-" + obj.thirdCameraId,
          {
            src: info.oldSrc || this.broadcastSrc, //默认状态
          }
        );
      } else {
        this.refMap.updateFeatureById(
          this.layerId,
          this.layerId + "-" + obj.thirdCameraId,
          {
            anchor: [26, 26],
            src: info.sleSrc || this.broadcastCheckSrc, //选中状态
          }
        );
        this.panelForm.deviceList.push(obj);
      }
      // console.log(this.panelForm.deviceList);
    },
    handelCenterPoint(info) {
      this.refMap.setMapCenter([+info.longitude, +info.latitude]);
    },
    handleAddDevice() {
      this.showIntercomList = true;
      this.isType = 1;
      this.$refs.deviceRef.checkNodeList = [...this.panelForm.micList];
      this.devicePanelTitle = "添加话筒";
    },
    handleAddAudio() {
      this.isType = 3;
      this.$refs.deviceRef.checkNodeList = [...this.panelForm.audioList];
      this.devicePanelTitle = "添加音频";
      this.showIntercomList = true;
    },
    handleChooseDevice(type) {
      // 2 广播
      this.isType = 2;
      this.showIntercomList = true;
      this.$refs.deviceRef.checkNodeList = [...this.panelForm.deviceList];
      this.devicePanelTitle = "添加广播设备";
      this.isType = type;
    },
    handleDelDevice(item, index, type) {
      if (type == 3) {
        this.panelForm.audioList.splice(index, 1);
        return;
      }
      this.panelForm.deviceList.splice(index, 1);
      // thirdCameraId
      this.refMap.updateFeatureById(
        this.layerId,
        this.layerId + "-" + item.thirdCameraId,
        {
          src: this.broadcastSrc, //默认状态
        }
      );
    },
    handleMapClearCheck() {
      let list = [...this.panelForm.deviceList];
      this.panelForm.deviceList = [];
      if (this.refMap.getMapZoom() > 16) {
        this.refMap.setMapZoom(16);
      }
      list.forEach((item) => {
        this.refMap.updateFeatureById(
          this.layerId,
          this.layerId + "-" + item.thirdCameraId,
          {
            src: this.broadcastSrc, //默认状态
          }
        );
      });
    },
    handleClosePanel() {
      this.handleMapClearCheck();
      this.$emit("handleCloseBroadcast");
      this.$nextTick(() => {
        this.$refs.panelForm.resetFields();
      });
    },
    handleSavePanel() {
      console.log(this.panelForm);
      this.$refs.panelForm.validate((result) => {
        if (result) {
          let params = {
            // 源终端ID，话筒
            sourceTerminalId: this.panelForm.sourceId,
            // 0 开始 1 停止
            stop: "0",
            //目标终端ID列表，广播设备
            targetTerminalIdList: this.panelForm.deviceList.map((item) => {
              return item.thirdCameraId;
            }),
          };
          this.saveIntercomForm(params, "开启", true);
        }
      });
    },
    handleSaveAudio() {
      this.$refs.panelForm.validate((result) => {
        if (result) {
          let params = {
            // 播放时长 单位秒
            durations: this.panelForm.playTime,
            // 文件名称列表
            fileList: this.panelForm.audioList,
            // 1：随机播放 0：顺序播放
            randomPlay: this.panelForm.playOrder,
            // 播放状态 startbct(开始广播) stopbct（停止广播）filecontrol （ 播放控制）  此接口固定传startbct(开始广播)
            rtType: "startbct",
            // 广播设备ID列表
            terminalIdList: this.panelForm.deviceList.map((item) => {
              return item.thirdCameraId;
            }),
          };
          this.$fetch(api.playAudio, params).then((res) => {
            if (res.success) {
              this.$message.success("音频创建成功");
              this.showIntercomPanel = false;
              this.handleClosePanel();
              this.$emit("handleSuccessBroadcast", 2);
            } else {
              this.$message.error(res.msgContent || "音频创建失败");
            }
          });
        }
      });
    },
    saveIntercomForm(params, opt = "操作", closeForm) {
      this.btnLoading = true;
      let optStr = `远程喊话${opt}`;
      this.$fetch(api.manualRemoteCall, params).then((res) => {
        this.btnLoading = false;
        if (res.success) {
          this.showIntercomPanel = false;
          this.$message.success(`${optStr}成功`);
          this.handleClosePanel();
          this.$emit("handleSuccessBroadcast", 1);
        } else {
          this.$message.error(res.msgContent || `${optStr}失败`);
        }
      });
    },
    handleClose() {
      this.showIntercomList = false;
      this.isType = 0;
    },
    handleConfirmList(list) {
      console.log(list);
      if (this.isType == 2) {
        // 该处选中的设备会覆盖已有的设备
        // 广播设备
        this.handleMapClearCheck();
        this.$nextTick(() => {
          list.forEach((item) => {
            this.handleDealDevice(item);
          });
          this.$refs.panelForm.validateField("deviceList");
        });
        // this.panelForm.deviceList = this.panelForm.deviceList.concat([...list]);
      } else if (this.isType == 3) {
        // 音频文件
        this.panelForm.audioList = [...list];
        this.$refs.panelForm.validateField("audioList");
      }
      this.handleClose();
    },
    handleConfirm(info) {
      console.log(info);
      this.panelForm.micList = [info];
      this.panelForm.sourceId = info.thirdDeviceId;
      this.panelForm.sourceName = info.name;
      this.$refs.panelForm.validateField("sourceId");
      // }
      this.handleClose();
    },
  },
};
</script>

<style lang="scss" scoped>
.broadcast-page {
  position: absolute;
  right: 0;
  width: 350px;
  height: 100%;
  z-index: 9;
  transition: right 0.3s;
  .ioc-alarm__list__item li {
    height: 100%;
  }
  .title {
    z-index: 2;
    padding: 12px 5px 12px 20px;
    background: #202631 !important;
  }
  .panelForm {
    background: rgba(24, 31, 46, 0.65);
    padding: 12px;
  }
  .content_value {
    padding: 10px;
  }
  .form-list {
    background: rgba(13, 18, 28, 0.65);
    margin-top: 12px;
    border-radius: 5px;
    width: 100%;
    display: flex;
    flex-direction: column;
    .no-data-text {
      height: 100px;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
  }
  .device-item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
    padding: 6px 6px;
    border-bottom: 1px solid #3b4253;
    &:last-child {
      border-bottom: none;
    }
  }
}
.showPanel {
  right: -350px !important;
}
.item-icon {
  font-size: 18px;
  color: #3e76e6;
  margin-right: 5px;
}
.footer {
  z-index: 2;
  text-align: center;
}
</style>
